import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "../../assets/css/admin.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";

const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "#f8f9fa",
        padding: "20px",
        borderRadius: "8px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        textAlign: "center",
    },
    overlay: {
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        zIndex: 1000,
    },
};

Modal.setAppElement("#root");

const NewsletterAdmin = () => {
    const { t } = useTranslation("admin");
    const [subscribers, setSubscribers] = useState([]);
    const navigate = useNavigate();
    const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
    const [actionToConfirm, setActionToConfirm] = useState(null);
    const [itemToDeleteOrUpdate, setItemToDeleteOrUpdate] = useState(null);
    const API_BASE_URL = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const fetchSubscribers = async () => {
            try {
                const token = localStorage.getItem("adminToken");
                if (!token) {
                    navigate("/connexion");
                    return;
                }
                const response = await axios.get(
                    `${API_BASE_URL}/api/admin/newsletter/emails`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
                setSubscribers(response.data);
            } catch (error) {
                console.error(
                    "Erreur lors de la récupération des abonnés:",
                    error
                );
                if (error.response && error.response.status === 401) {
                    navigate("/connexion");
                }
            }
        };

        fetchSubscribers();
    }, [navigate]);

    const openConfirmationModal = (action, item) => {
        setActionToConfirm(action);
        setItemToDeleteOrUpdate(item);
        setConfirmationModalOpen(true);
    };

    const closeConfirmationModal = () => {
        setActionToConfirm(null);
        setItemToDeleteOrUpdate(null);
        setConfirmationModalOpen(false);
    };

    const handleConfirmAction = async () => {
        if (actionToConfirm === "deleteSubscriber" && itemToDeleteOrUpdate) {
            await handleDeleteSubscriber(itemToDeleteOrUpdate);
        }
        closeConfirmationModal();
    };

    const handleDeleteSubscriber = async (emailToDelete) => {
        try {
            const token = localStorage.getItem("adminToken");
            if (!token) {
                navigate("/connexion");
                return;
            }
            await axios.delete(
                `${API_BASE_URL}/api/admin/newsletter/emails/${encodeURIComponent(
                    emailToDelete
                )}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setSubscribers(
                subscribers.filter(
                    (subscriber) => subscriber.email !== emailToDelete
                )
            );
        } catch (error) {
            console.error("Erreur lors de la suppression de l'abonné:", error);
            if (error.response && error.response.status === 401) {
                navigate("/connexion");
            }
        }
    };

    const confirmDeleteSubscriber = (email) => {
        openConfirmationModal("deleteSubscriber", email);
    };

    return (
        <section className="manage-newsletter admin-dashboard">
            <h2>{t("manage_newsletter")}</h2>
            {subscribers.length > 0 ? (
                <table>
                    <thead>
                        <tr>
                            <th>{t("nom")}</th>
                            <th>{t("email")}</th>
                            <th>{t("actions")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {subscribers.map((subscriber, index) => (
                            <tr key={index}>
                                <td>{subscriber.nom}</td>
                                <td>{subscriber.email}</td>
                                <td>
                                    <button
                                        className="deleteadm"
                                        onClick={() =>
                                            confirmDeleteSubscriber(
                                                subscriber.email
                                            )
                                        }
                                    >
                                        {t("delete_subscriber")}
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                <p>{t("no_subscribers")}</p>
            )}

            {/* Confirmation Modal */}
            <Modal
                isOpen={confirmationModalOpen}
                onRequestClose={closeConfirmationModal}
                style={customStyles}
                contentLabel={t("confirmation_modal_title")}
            >
                <h2>{t("confirmation_modal_title")}</h2>
                <p>{t("confirm_delete_subscriber")}</p>
                <button
                    onClick={handleConfirmAction}
                    className="confirm-button"
                >
                    {t("confirm")}
                </button>
                <button
                    onClick={closeConfirmationModal}
                    className="cancel-button"
                >
                    {t("cancel")}
                </button>
            </Modal>
        </section>
    );
};

export default NewsletterAdmin;
